"use client"
import { HelpCircle, ClipboardList, Eye } from "lucide-react";

export default function ClinicalQuestions({ clinicalQuestions }) {
    if (!clinicalQuestions) return null;

    return (
        <div className="pt-2">
            <h3 className="text-base sm:text-lg font-semibold text-gray-900 mb-3 sm:mb-4 flex items-center gap-2">
                <HelpCircle className="w-4 h-4 sm:w-5 sm:h-5 text-[#0B7BC1] flex-shrink-0" />
                Clinical Questions for Workup
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-4">
                {clinicalQuestions.history_questions && clinicalQuestions.history_questions.length > 0 && (
                    <div className="p-3 sm:p-4 bg-purple-50 border border-purple-200 rounded-lg">
                        <h4 className="text-xs sm:text-sm font-semibold text-purple-900 mb-2 flex items-center gap-2">
                            <ClipboardList className="w-3.5 h-3.5 sm:w-4 sm:h-4 flex-shrink-0" />
                            History Questions
                        </h4>
                        <ul className="space-y-1 sm:space-y-1.5">
                            {clinicalQuestions.history_questions.map((q, index) => (
                                <li key={index} className="text-xs sm:text-sm text-purple-800 flex gap-2">
                                    <span className="text-purple-400 flex-shrink-0">{index + 1}.</span>
                                    <span className="break-words">{q}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                )}
                {clinicalQuestions.physical_exam_focus && clinicalQuestions.physical_exam_focus.length > 0 && (
                    <div className="p-3 sm:p-4 bg-blue-50 border border-blue-200 rounded-lg">
                        <h4 className="text-xs sm:text-sm font-semibold text-blue-900 mb-2 flex items-center gap-2">
                            <Eye className="w-3.5 h-3.5 sm:w-4 sm:h-4 flex-shrink-0" />
                            Physical Exam Focus
                        </h4>
                        <ul className="space-y-1 sm:space-y-1.5">
                            {clinicalQuestions.physical_exam_focus.map((item, index) => (
                                <li key={index} className="text-xs sm:text-sm text-blue-800 flex gap-2">
                                    <span className="text-blue-400 flex-shrink-0">{index + 1}.</span>
                                    <span className="break-words">{item}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                )}
            </div>
        </div>
    );
}
